// extracted by mini-css-extract-plugin
export default {"fondo_card":"card_fondo_card__lqAa2","list_product":"card_list_product__ubzlE","link_card":"card_link_card__GTdyN"};